import {Component} from 'react';
import TableDisplayCard from '../shared-components/table_display_card';
import ThreeColumnTableCard from './three_column_table_card';
import TwoColumnTableCard from './two_column_table_card';

class CarChangeModalTables extends Component {
  constructor(props) {
    super(props);
  }
  
  render(){
        this.monthlyCosts = this.props.monthlyAmtArr.map((amountArr,key) =>
          <TableDisplayCard key={key}  outInfo={amountArr}  />
        );
        let infoType = "label-amount-amount";
        this.monthlyCompareAmts = this.props.monthlyCompareAmtArr.map((monthAmts, key) =>
            <ThreeColumnTableCard key={key} outInfo={monthAmts} 
                infoType={infoType} labelClass="font-weight-bold"  />
            );
        this.cashAmounts = this.props.cashAmtArr.map((amountArr,key) =>
          <TableDisplayCard key={key}  outInfo={amountArr}  />
        );
        this.moodPointList = this.props.moodPointStartArr.map((moodPoints,key) =>
          <TwoColumnTableCard key={key} infoType="label-number" outInfo={moodPoints}  />
        );
    
  return (
    <>
    <div>
        <h5 className="text-center mt-2">Car Monthly Amounts</h5>  
        <table className="table table-hover">
            <tbody>
                {this.monthlyCosts}
                <tr>
                    <th></th>
                    <th className="text-right">Current Cost</th>
                    <th className="text-right">New Cost</th>
                </tr>
                {this.monthlyCompareAmts}
            </tbody>
        </table>
        {this.props.loanMonthsRemaining > 0 ?
            <div className="font-weight-bold text-green">
            <b>Good News!</b> The trade-in and cash down amount will be applied to the current car loan.
                You now have&nbsp;
            {this.props.loanMonthsRemaining} months left to pay instead of&nbsp;
            {this.props.currentCarLoanMonths} .
            </div>
        :
            null
        }
        <h5 className="text-center mt-2">Changes to Cash Amounts</h5>  
        <table className="table table-hover">
            <tbody>
                {this.cashAmounts}
            </tbody>
        </table>

        <h5 className="text-center">Mood Point Calculation</h5>
        <div>{this.props.moodPointText}</div>
        <table className="table table-hover">
            <tbody className="row-100">
                <tr>
                    <th className="text-center p-0">Description</th>
                    <th className="text-right p-0">Mood Points</th>
                </tr>
                {this.moodPointList}
            
            </tbody>
        </table>
    </div>
  
    </>
  )
 }
  
}
export default CarChangeModalTables;